import { Button } from '@accure/ui';
import { Minus, Plus } from 'lucide-react';

import { Tooltip } from '@/components/ui/tooltip';
import { formatPercentage } from '@/utils/format/number';

export type ScaleControllerProps = {
  value?: number;
  onChange?: (v: number) => void;
  increment?: number;
};
export function ScaleController({
  value = 1,
  onChange,
  increment = 0.1,
}: ScaleControllerProps) {
  return (
    <div className="flex items-center gap-2">
      <Button
        variant="ghost"
        onClick={function () {
          if (value - increment > 0.1) {
            onChange?.(value - increment);
          }
        }}
      >
        <Minus />
      </Button>
      <Tooltip delay content="Reset to 100%">
        <div
          className="w-12 cursor-pointer text-center font-normal"
          onClick={() => onChange?.(1)}
        >
          {formatPercentage(value, 0)}
        </div>
      </Tooltip>
      <Button variant="ghost" onClick={() => onChange?.(value + increment)}>
        <Plus />
      </Button>
    </div>
  );
}
